<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<template>
  <afterpay-placement
    v-if="$variable('settings.enableAfterpay')"
    :id="`afterpay-placement-${namespace}`"
    class="afterpay-messaging"
    :data-amount="price / 100"
    data-badge-theme="white-on-black"
    :data-currency="currency"
    :data-intro-text="$string('general.afterpay.intro_text')"
    :data-locale="locale"
    data-logo-type="compact-badge"
    data-modal-link-style="learn-more-text"
    data-modal-theme="white"
    data-payment-amount-is-bold="false"
    data-show-interest-free="true"
    data-show-with="false"
    data-size="xs"
  >
    <span
      slot="learn-more-link"
      class="afterpay-messaging__link"
      v-text="$string('general.afterpay.learn_more')"
    />
  </afterpay-placement>
</template>

<script>

/**
 * Vue: Afterpay messaging (afterpay-messaging)
 * -----------------------------------------------------------------------------
 * Afterpay on-site messaging component.
 *
 * @param {String} namespace - Placement namespace.
 * @param {Number} price - Product, variant, or cart price.
 *
 */
export default {
  name: 'AfterpayMessaging',

  props: {
    namespace: {
      type: String,
      default: '',
      required: true,
    },
    price: {
      type: Number,
      default: 0,
      required: true,
    },
  },

  computed: {

    /**
     * Compute locale.
     * @returns {String}
     */
    locale() {
      return `${cnvs.store.language}-${cnvs.store.country}`
    },

    /**
     * Compute currency.
     * @returns {String}
     */
    currency() {
      return cnvs.store.currency
    },
  },
}
</script>

<style lang="scss">
@import './afterpay-messaging';
</style>
